import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle, FormControl } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const ApplicationEditModal = ({
  open,
  handleClose,
  editLoading,
  onEdit,
  initialValues,
}) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: { title: '', key: '' },
  });

  useEffect(() => {
    if (open) {
      reset({
        title: initialValues?.title ?? '',
        key: initialValues?.key ?? '',
      });
    }
  }, [open, initialValues, reset]);

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ویرایش برنامه</DialogTitle>

      <DialogContent>
        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              autoFocus
              label="نام برنامه"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('title', { required: 'عنوان الزامی است' })}
              error={isSubmitted ? !!errors.title : null}
              helperText={errors.title?.message}
            />
          </FormControl>
        </FormFieldWrapper>

        <FormFieldWrapper>
          <FormControl variant="standard" sx={{ m: 2, minWidth: 300 }}>
            <TextField
              label="کلید"
              variant="standard"
              sx={{ minWidth: 300 }}
              {...register('key', { required: 'کلید الزامی است' })}
              error={isSubmitted ? !!errors.key : null}
              helperText={isSubmitted ? errors.key?.message : null}
            />
          </FormControl>
        </FormFieldWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={editLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit(onEdit)}
          loading={editLoading}
          color="warning"
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ApplicationEditModal;
const FormFieldWrapper = styled.div`
  margin: 20px 8px 0;
  min-width: 300px;
`;
